(function slickThemeScript($, Drupal) {
  Drupal.behaviors.biofinSlick = {
    attach: function(context, settings) {
      var slider = $(".slider");

      slider.each(function() {
        if ($(this).is(".slideshow__slides")) {
          $(this).slick({
            dots: true,
            customPaging: function(slider, i) {
              return '<a href="#"><i class="fa fa-circle" aria-hidden="true"></i></a>';
            },
            autoplay: true,
            speed: 1500,
            adaptiveHeight: true,
            slidesToShow: 1,
            appendArrows: $('.slideshow__slides'),
            prevArrow: '<div class="left carousel-control"><button class="icon-prev slick-arrow slick-prev"></button></div>',
            nextArrow: '<div class="right carousel-control"><button class="icon-next slick-arrow slick-next"></button></div>',
            responsive: [{
              breakpoint: 768,
              settings: {
                dots: false,
                //centerMode: true,
              }
            }],
          });
        } else if ($(this).is('.view-publications-carousel')) {
          $(this).slick({
            dots: false,
            autoplay: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            speed: 300,
            appendArrows: $('.view-publications-carousel'),
            prevArrow: '<div class="left carousel-control"><button class="icon-prev slick-arrow slick-prev"></button></div>',
            nextArrow: '<div class="right carousel-control"><button class="icon-next slick-arrow slick-next"></button></div>',
            responsive: [{
                breakpoint: 1250,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1
                }
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              }
            ] // end responsie
          }); // end second slice config
        } else if ($(this).is('.view-webinars-carousel')) {
          $(this).slick({
            dots: false,
            autoplay: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            speed: 300,
            appendArrows: $('.view-webinars-carousel'),
            prevArrow: '<div class="left carousel-control"><button class="icon-prev slick-arrow slick-prev"></button></div>',
            nextArrow: '<div class="right carousel-control"><button class="icon-next slick-arrow slick-next"></button></div>',
            responsive: [{
              breakpoint: 1250,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              }
            ] // end responsie
          }); // end second slice config
        } else {
          $(this).slick();
        } // end of logic
      }); // end of each
    }
  }
}(jQuery, Drupal));
